/*
 * Purpose: Mission goal banner — pinned to top of map well, human-readable outcome
 * Last modified: 2026-07-10 | Agent
 * Completeness: 100
 */
import { Target } from 'lucide-react';
import { useWorkflowStore } from '@/stores/workflowStore';
import { getMissionGoalIntent } from '@/lib/mapNodeSummary';
import { isLiveBuildActive, useMissionLiveBuildStore } from '@/stores/missionLiveBuildStore';
import { cn } from '@/lib/utils';

export function MissionMapGoalBanner() {
  const currentWorkflow = useWorkflowStore((s) => s.currentWorkflow);
  const liveBuildStatus = useMissionLiveBuildStore((s) => s.status);
  const liveBuildActive = isLiveBuildActive(liveBuildStatus);

  const intent = getMissionGoalIntent(currentWorkflow);

  return (
    <div
      className={cn(
        'pointer-events-none absolute inset-x-0 z-20 flex justify-center px-2 sm:px-3',
        liveBuildActive ? 'top-[4.75rem] sm:top-[5.25rem]' : 'top-2 sm:top-3'
      )}
      role="region"
      aria-label="Mission goal"
    >
      <div
        className={cn(
          'pointer-events-auto flex w-full max-w-2xl items-start gap-2.5 rounded-xl border',
          'border-ab-green-core/35 bg-card/92 px-3 py-2 shadow-md backdrop-blur-sm sm:gap-3 sm:px-4 sm:py-2.5',
          'dark:border-ab-green-glow/35'
        )}
      >
        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-ab-green-mist/80 dark:bg-ab-green-forest/40">
          <Target className="h-3.5 w-3.5 text-ab-green-deep dark:text-ab-green-glow" aria-hidden />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
            Mission goal
          </p>
          <p className="mt-0.5 text-sm font-medium leading-snug text-foreground line-clamp-3 sm:line-clamp-2">
            {intent}
          </p>
        </div>
      </div>
    </div>
  );
}

export default MissionMapGoalBanner;
